<template>

	<form @submit.prevent="onSubmit" novalidate>

		<steps :current="4" :total="5" label="Financing Programs" />

		<mdb-card class="under-nav">

			<mdb-container>

				<mdb-card-body>

					<form-field v-model="vModels.type" name="type" type="btn-group" :label="$t('financingProgram.program')"
						bootstrap>

						<btn v-for="type in mainButtons" :key="type.value" type="button" :value="type.value" color="primary"
							:active="type.value === vModels.type" class="p-4" @click.native="vModels.type = type.value">

							<span>{{ type.text }}</span>

						</btn>


					</form-field>

				</mdb-card-body>

			</mdb-container>

		</mdb-card>

		<mdb-container>

			<mdb-row>
				<mdb-col>

					<mdb-card>

						<mdb-card-body >
							<fieldset>
								<label for="installerName" class="h5 font-weight-bold">{{ $t("certification.installerName")
									}}:</label>
								<form-field v-model="vModels.installerName" name="installerName" type="text" bootstrap required>
								</form-field>

								<label for="installerEmail" class="h5 font-weight-bold">{{ $t("certification.installerEmail")
									}}:</label>
								<form-field v-model="vModels.installerEmail" name="installerEmail" type="email" bootstrap required>
								</form-field>
								
								<label for="installerEmail" class="h5 font-weight-bold">{{ $t("certification.installerCompany")
									}}:</label>
								<form-field v-model="vModels.installerCompany" name="installerCompany" type="text" bootstrap required>
								</form-field>

								<button v-if="vModels.type == 'paper'" type="button"
									class="btn btn-info btn-lg btn-block btn-rounded ripple-parent btn-with-absolute-loader"
									@click="generateCompletionCert('paper')">Download Document</button>

								<button v-if="vModels.type == 'electronic'" type="button"
									class="btn btn-info btn-lg btn-block btn-rounded ripple-parent btn-with-absolute-loader"
									:disabled="!(vModels.installerName && vModels.installerEmail)"
									@click="generateCompletionCert('electronic')">{{ $t('sign.request') }}</button>
								<br>

							</fieldset>
						</mdb-card-body>

					</mdb-card>

					<div class="form-group mt-4 button-row">

						<submit-btn tabindex="2" @click="$router.push({ name: 'Sign', params: $route.params })">{{
							$t('forms.back')
							}}</submit-btn>

						<submit-btn tabindex="1" v-if="true" @click="$router.push({ name: 'UploadFilesStep1', params: $route.params })">{{
							$t('forms.saveNext') }}</submit-btn>

					</div>

				</mdb-col>
			</mdb-row>

		</mdb-container>

	</form>

</template>

<script>

	import { kebabCase, camelCase } from 'change-case';
	import FormsMixin from './ApplicationForms/FormsMixin';
	import { generateCompletionCertApi } from '../../api';

	export default {

		components: {
		},

		mixins: [
			FormsMixin
		],

		data() {

			return {
				mainButtons: [
					{ text: 'Electronic', value: 'electronic' },
					{ text: 'Paper', value: 'paper' }
				],
				vModels: {
					type: 'electronic',
					installerName: '',
					installerEmail: '',
					installerCompany: ''
				}
			};

		},

		mounted() {

			// this.checkUploadStatus();

		},

		methods: {

			kebabCase: val => kebabCase(val),

			getRoute(name) {

				return {
					name: 'UploadFilesStep2',
					params: {
						id: this.$route.params && this.$route.params.id,
						type: kebabCase(name)
					}
				};

			},

			completedSteps(name) {

				return (name === 'otherUpload1') ? 1 : 0;

			},

			totalSteps(name) {

				console.log(name);

				return 1;

			},

			async generateCompletionCert(method) {

				console.log(this.application.data.id);

				this.saveLoading(true);

				let payload = {
					id: this.application.data.id,
					installerEmail: this.vModels.installerEmail,
					installerName: this.vModels.installerName,
					installerCompany: this.vModels.installerCompany,
					method
				}

				let result = await generateCompletionCertApi(payload).catch(error => {

					let errorMsg = error.toString();

					if (error.response && error.response.data && error.response.data.errorMessage) {

						errorMsg = error.response.data.errorMessage;

					}

					if (errorMsg) {

						this.showErrorAlert(errorMsg);

					}

				});

				console.log('result', result);

				if (
					method == 'paper'
					|| result.data.base64
				) {

					let byteCharacters = atob(result.data.base64);
					let byteNumbers = new Array(byteCharacters.length);

					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}

					try {
						
						let byteArray = new Uint8Array(byteNumbers);
						let file = new Blob([byteArray], { type: 'application/pdf' });
						// let fileURL = URL.createObjectURL(file);
						// let newWin = window.open(fileURL);
						let fileURL = URL.createObjectURL(file);
						let a = document.createElement('a');
						a.href = fileURL;
						a.download = (this.application.data.edgeId || '') + '-completion-certificate.pdf';
						document.body.appendChild(a);
						a.click();
						document.body.removeChild(a);
						URL.revokeObjectURL(fileURL); // Clean up

						this.showSuccessAlert('Download has been initiated. Check if a pop up blocker is blocking the download.');

					} catch (error) {
						this.showErrorAlert(error);
					}


					// if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
					// 	let errorMsg = this.$i18n.t('sign.popupNotice');
					// 	this.isShowPopupNotice = true;
					// } else {
					// }

				} else if (
					method == 'electronic'
					&& result.data.status == "Success"
				) {
					this.showSuccessAlert('Emails have been sent for signature.');
				} else {
					this.errorAlert = await this.showErrorAlert(result);
				}

				this.saveLoading(false);

			}

		}

	};

</script>

<style lang="scss" scoped>

/deep/ .btn-group {
	display: flex;
	flex-wrap: wrap;

	.btn {
		border-radius: $btn-border-radius !important;
		width: 30%;
		max-width: 31.5%;
		margin: 1rem 1% !important;

		&.lease-date {
			// margin: 1rem 1%;
			width: 10%;

			@media (max-width: 767px) {
				width: 100%;
				margin: 0.2rem 0%;
				padding: 10px !important;
			}
		}

		@media (max-width: 767px) {
			width: 100%;
			margin: 0.5rem 0%;

			&.program-btn {
				padding: 10px !important;
			}

			span.rate {
				font-size: 2rem !important;
			}

		}



		span {
			display: block;
		}

		&.btn-primary {

			&.active,
			&:active {
				background-color: $info !important;
			}
		}

	}

}

</style>
